export const generateGridCols = (
	width: number,
	inc: number,
	maxCols: number,
	isMonitor: boolean,
) => {
	if (!width || !maxCols) return;

	const baseWidth = isMonitor ? 300 : 600;
	let numCols = Math.trunc((width - baseWidth) / inc) + 1;

	numCols = Math.min(numCols, maxCols);

	return { gridTemplateColumns: `repeat(${numCols}, minmax(0, 1fr))` };
};
